/*global VeloxFormController, VeloxWebView*/

const PRODUCTS = require("../../util/products");
var upload = require("../../util/upload") ;

var resellerSettingsController = new VeloxFormController("reseller_settings", {
    directory: "views/reseller",
    name: "resellerSettings",
    route: "reseller_settings",
    openInPopup: true,
    popup: {
        size: "medium"
    }
});

resellerSettingsController.getLogo = function(reseller_settings, callback){
    if(reseller_settings && reseller_settings.binary){
        this.api.readBinary.url(reseller_settings.binary, function(err, url){
            if(err){ return callback(err) ;}
            callback(null, url) ;
        }) ;
    }else{
        callback(null, "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8zwQAAgYBAyKDV6YAAAAASUVORK5CYII=") ;
    }
} ;

resellerSettingsController.getDefaultData = function(callback){
    this.api.api.reseller_settings.searchFirst({}, [
        {otherTable: "velox_binary", type: "2one", thisField: "r_code", otherField:"table_uid", name: "binary"}
    ], function(err, settings){
        if(err){ return callback(err) ;}
        var defaultData = settings || {} ;
        defaultData.country =  VeloxWebView.country.get();
        var schema = VeloxWebView.fieldsSchema.getSchema();
        //defaultData.u_id = this.api.currentUser.uid;
        this.prepareRecord(schema, this.table, defaultData) ;
        
        this.getLogo(defaultData, function(err, logoUrl){
            if(err){ return callback(err) ;}
            defaultData.logoUrl = logoUrl ;
            if(!defaultData.rs_email){
                defaultData.rs_email = this.api.currentUser.email ;
            }
    
            defaultData.r_code = this.api.currentReseller ;
            
            callback(null,defaultData);
        }.bind(this)) ;
    }.bind(this)) ;
} ;

resellerSettingsController.onChangeMode = function(ev){
    if(ev.data === "read"){
        this.jsonBeforeModif = JSON.stringify(this.view.getBoundObject()) ;
        this.setMode("modify") ;
    }
} ;

resellerSettingsController.validations.push(function checkProducts(params, callback){
    

    if(PRODUCTS.BAYROL.pool.CL.SHOCK.every(function(p){ return params.data.rs_hidden_products_bayrol.indexOf(p) !== -1 ;})){
        return callback(null, this.view.tr("settings.youCantDisableAllBAYROLClShockProducts")) ;
    }
    if(PRODUCTS.BAYROL.pool.CL.LONG.every(function(p){ return params.data.rs_hidden_products_bayrol.indexOf(p) !== -1 ;})){
        return callback(null, this.view.tr("settings.youCantDisableAllBAYROLClLongProducts")) ;
    }
    if(PRODUCTS.BAYROL.pool.O2.LONG.every(function(p){ return params.data.rs_hidden_products_bayrol.indexOf(p) !== -1 ;})){
        return callback(null, this.view.tr("settings.youCantDisableAllBAYROLO2LongProducts")) ;
    }
    if(PRODUCTS.BAYROL.pool.BR.SHOCK.every(function(p){ return params.data.rs_hidden_products_bayrol.indexOf(p) !== -1 ;})){
        return callback(null, this.view.tr("settings.youCantDisableAllBAYROLBrShockProducts")) ;
    }
    if(PRODUCTS.BAYROL.pool.ALG.every(function(p){ return params.data.rs_hidden_products_bayrol.indexOf(p) !== -1 ;})){
        return callback(null, this.view.tr("settings.youCantDisableAllBAYROLAlgaeProducts")) ;
    }
    if(PRODUCTS.AQUAPURE.pool.CL.SHOCK.every(function(p){ return params.data.rs_hidden_products_aquapure.indexOf(p) !== -1 ;})){
        return callback(null, this.view.tr("settings.youCantDisableAllAQUAPUREClShockProducts")) ;
    }
    if(PRODUCTS.AQUAPURE.pool.CL.LONG.every(function(p){ return params.data.rs_hidden_products_aquapure.indexOf(p) !== -1 ;})){
        return callback(null, this.view.tr("settings.youCantDisableAllAQUAPUREClLongProducts")) ;
    }
    if(PRODUCTS.AQUAPURE.pool.O2.LONG.every(function(p){ return params.data.rs_hidden_products_aquapure.indexOf(p) !== -1 ;})){
        return callback(null, this.view.tr("settings.youCantDisableAllAQUAPUREO2LongProducts")) ;
    }
    if(PRODUCTS.AQUAPURE.pool.ALG.every(function(p){ return params.data.rs_hidden_products_aquapure.indexOf(p) !== -1 ;})){
        return callback(null, this.view.tr("settings.youCantDisableAllAQUAPUREAlgaeProducts")) ;
    }
    callback() ;
}.bind(resellerSettingsController)) ;

resellerSettingsController._onBtValidate = function(){
    this.view.longTask(function(done){

        this.doValidate(function(err, savedRecord){
            if(err){ return done(err); }
            if(!savedRecord){
                //check failed
                return done() ;
            }
            this.navigate("..") ;
            done() ;
        }.bind(this)) ;
    }.bind(this)) ;
};

resellerSettingsController.getSettings = function(callback){
    this.api.api.reseller_settings.searchFirst({}, function(err, settings){
        if(err){ return callback(err) ;}

        if(settings){
            return callback(null, settings) ;
        }
        this.api.api.reseller_settings.insert({r_code : this.api.currentReseller}, callback) ;
    }.bind(this)) ;
}


/**
 * User want to upload a logo
 */
resellerSettingsController.onUploadLogo = function(){
    upload({
        multiple: false, 
        accept: "image/gif,image/jpeg,image/png",
        sizeLimit: 500000
    },function(file){
        if(!file){ return ;}
        this.view.updateData() ;
        this.view.longTask(function(done){
            this.api.api.reseller_settings.searchFirst({}, function(err, settings){
                if(err){ return done(err) ;}

                //create settings if not exists
                (function(settings, cb){
                    if(!settings){
                        this.api.api.reseller_settings.insert({r_code : this.api.currentReseller}, cb) ;
                    }else{
                        cb(null, settings) ;
                    }
                }.bind(this))(settings, function(err, settings){
                    if(err){ return done(err) ;}

                    var binaryRecord = {
                        table_name: "reseller_settings", 
                        table_uid: settings.r_code, 
                        mime_type: file.type,
                        description : file.name,
                        filename: "logo"
                    };
                    if(this.data.binary){
                        binaryRecord.uid = this.data.binary.uid ;
                    }
                    this.api.saveBinary(
                    file,
                    binaryRecord, function(err, binary){
                        if(err){ return done(err) ;}
                        this.getLogo(this.data, function(err, logoUrl){
                            if(err){ return done(err) ;}
                            if(logoUrl.indexOf("http")===0){
                                logoUrl += "?"+new Date().getTime() ;
                            }
                            this.data.logoUrl = logoUrl;
                            this.data.binary = binary ;
                            this.view.render() ;
                        }.bind(this)) ;
                        done() ;
                    }.bind(this)) ;
                }.bind(this)) ;
            }.bind(this)) ;
        }.bind(this)) ;
    }.bind(this));
} ;


module.exports = resellerSettingsController ;